import { ObservableMap } from '@stencil/store';
import { handleLanguageChange } from '@uipath/portal-shell-util';

import { updateLocale } from '../../components/portal-notification/helpers/notificationApi';
import { EventHandlersInstanceResolver } from '../../utils/events/eventHandlersInstanceResolver';
import GlobalEventEmitter from '../../utils/events/globalEventEmitters';
import { Features } from '../../utils/featureFlags/featureFlagConstants';
import { getFeatureFlag } from '../../utils/featureFlags/featureFlags';
import { isFalsyOrWhitespace } from '../../utils/helper';
import { setStoreLanguage } from '../../utils/languageHelper';
import Logger from '../../utils/logger/logger';
import { getAccessToken } from '../../utils/session/sessionStore';
import { State } from '../types/state';

export function setLocaleSideEffect(store: ObservableMap<State>) {
    handleLanguageChange(language => {
        setStoreLanguage(store, language);
    });
    store.onChange('locale', async (locale) => {
        const testLanguageFlag = getFeatureFlag(Features.EnableLocKeysLanguage.name);
        if (isFalsyOrWhitespace(locale)
            || (!testLanguageFlag && locale === 'keys')
            || (!getFeatureFlag(Features.EnableLanguageZhTw.name) && locale.toLocaleLowerCase() === 'zh-tw')) {
            return;
        }

        const languageEvent = { selectedLanguageId: locale };
        const defaultEmitter = store.get('languageChangedEmitter');
        GlobalEventEmitter.emitLanguageChanged(
            languageEvent,
            defaultEmitter ? () => defaultEmitter.emit(languageEvent) : undefined,
        );
        EventHandlersInstanceResolver.Instance?.onLanguageChanged?.(languageEvent);

        Logger.debug('store', `setting lang attr: ${locale}`);
        document.documentElement.setAttribute('lang', locale);

        Logger.debug('pendo', 'updating language');
        window.PortalShell.Pendo.updateVisitorOptions({ language: locale });

        if (getFeatureFlag(Features.EnableNotification.name) && locale !== 'keys') {
            const accessToken = getAccessToken();
            try {
                accessToken && await updateLocale(accessToken, locale);
            } catch (error) {
                Logger.warn('ap-shell', 'updateLocale', error);
            }
        }
    });
}
